import Vue from "vue"
import App from "./App.vue"
import router from './router'
import FoundationCSS from "foundation-sites/dist/css/foundation.min.css"
import AnimateCSS from "animate.css/animate.min.css"
import FontAwesomeCSS from "@fortawesome/fontawesome-free/css/fontawesome.min.css"
import VueGtag from "vue-gtag"
import VueSmoothScroll from "vue2-smooth-scroll"
import VueSimpleAlert from "vue-simple-alert"
import qs from "qs"
import axios from "axios"
import VueAxios from "vue-axios"

Vue.config.productionTip = false;

Vue.use(VueGtag, {
      config: { 
            id: "UA-177173085-5"
      }
}, router)
Vue.use(VueSmoothScroll, {offset: 0})
Vue.use(VueSimpleAlert)
Vue.use(VueAxios, axios)
Vue.use(qs)

new Vue({
  router,
  FoundationCSS,
  AnimateCSS,
  FontAwesomeCSS,
  render: h => h(App)
}).$mount("#app");
